import type { AxiosResponse } from "axios";

import { getData, postData } from "@/apis/apiInstance";

import type { MaintenanceTypePayload } from "@/commonTypes/maintenanceTypes";

import { getCSRFToken } from "@/utils/commonFunctions";

export async function scheduleMaintenanceApi(
  data: MaintenanceTypePayload
): Promise<AxiosResponse> {
  const { token, start_time, end_time, under_maintenance } = data;

  let finalData = {
    start_time,
    end_time,
    under_maintenance,
  };

  return await postData(`schedule/maintenance`, finalData, {
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
      "x-csrf-token": getCSRFToken(),
    },
  });
}

export async function getMaintenanceDataApi(): Promise<AxiosResponse> {
  return await getData(`maintenance`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
}
